import Model, { attr, hasMany } from '@ember-data/model';
import type LedgerEntryModel from './ledger-entry.ts';
import { Type } from '@warp-drive/core-types/symbols';
import type { LedgerProduct } from './ledger-account.ts';

export type LedgerEventStatus = 'PENDING' | 'POSTED';

export default class LedgerEventModel extends Model {
  @attr declare description: string;
  @attr declare eventDate: string;
  @attr declare eventType: string;
  @attr declare itemType: string;
  @attr declare itemId: number;
  @attr declare metadata: Record<string, unknown> | null;
  @attr declare postedAt: string;
  @attr declare product: LedgerProduct;
  @attr declare status: LedgerEventStatus;

  @hasMany('ledger-entry', { async: false, inverse: 'ledgerEvent' })
  declare ledgerEntries: LedgerEntryModel[];

  [Type] = 'ledger-event' as const;
}
